import { Form, Input, InputNumber, Typography } from "antd";
import React, { useState } from "react";
import DeselectableRadioGroup from "../../../../blocks/FormItems/DeselectableRadioGroup";
import inputStyles from "../../../../styles/Custom/Input.module.css";
const nourishmentOptions = [
  { label: "Well nourished", value: "well_nourished" },
  { label: "Malnourished", value: "malnourished" },
];
const NutritionalScreening = ({ form }) => {
  const [states, setStates] = useState({ height: null, weight: null });

  const calculateBmi = () => {
    const { height, weight } = states;
    if (!height || !weight) return null;

    const bmiValue = (weight / (height * height)).toFixed(2);

    let status = "Underweight";
    if (bmiValue >= 30) {
      status = "Obese";
    } else if (bmiValue >= 25) {
      status = "Overweight";
    } else if (bmiValue >= 18.5) {
      status = "Normal";
    }

    return ` : ${bmiValue}kgs/sq.m (${status})`;
  };

  return (
    <>
      <Typography>
        BMI{states?.height && states?.weight && calculateBmi()}
      </Typography>
      <Form.Item label="Height" name={["bmi", "height"]}>
        <InputNumber
          addonAfter="cm"
          onChange={(value) => {
            setStates((prev) => ({ ...prev, height: value / 100 })); // convert cm to meters
          }}
        />
      </Form.Item>
      <Form.Item label="Weight" name={["bmi", "weight"]}>
        <InputNumber
          addonAfter="kg"
          onChange={(value) => {
            setStates((prev) => ({ ...prev, weight: value }));
          }}
        />
      </Form.Item>
      <Form.Item label="Ideal Body weight" name={"ideal_body_weight"}>
        <Input
          className={inputStyles.mdInput}
          style={{ width: "250px" }}
          placeholder="History of present illness"
        />
      </Form.Item>
      <DeselectableRadioGroup
        label={"Nourishment"}
        name={"nourishment"}
        options={nourishmentOptions}
        form={form}
      />
    </>
  );
};

export default NutritionalScreening;
